<template>
  <div>
    <b-modal
      id="modal-team-init"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      :title="$t('popups.user.init-team.title')"
    >
      <div class="vx-row">
        <div class="vx-col w-full">

          <validation-observer ref="initTeamValidation">
            <form
              id="initTeamForm"
              @submit.prevent
            >
              <!--              <div class="vx-row mb-2">-->
              <!--                <div class="vx-col w-full">-->

              <div>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('popups.user.init-team.team-definition')"
                  rules="required"
                >
                  <label for="team-definition">
                    {{ $t('popups.user.init-team.team-definition') }}
                  </label>
                  <b-form-group>
                    <v-select
                      id="team-definition"
                      v-model="myTeam.teamDefinition"
                      :placeholder="$t('popups.user.init-team.select-team-definition')"
                      :options="filteredTeamDefinitions"
                      :disabled="loading"
                      :clearable="false"
                      :searchable="false"
                      label="code"
                      :reduce="name => name.id"
                    >
                      <span slot="no-options">{{ $t('popups.user.init-team.select-team-definition-no-result') }}</span>
                    </v-select>
                    <small
                      v-if="teamDefinitionHint"
                      class="form-text text-muted"
                    >
                      {{ teamDefinitionHint }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>

              <div>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('popups.user.init-team.vehicle')"
                  rules="required"
                >
                  <label for="vehicle">
                    {{ $t('popups.user.init-team.vehicle') }}
                  </label>
                  <b-form-group>
                    <v-select
                      id="vehicle"
                      v-model="myTeam.vehicle"
                      :placeholder="$t('popups.user.init-team.select-vehicle')"
                      :options="vehicles"
                      :get-option-label="getVehicleOptionLabel"
                      :disabled="loading"
                      :clearable="false"
                      :searchable="false"
                      :reduce="name => name.id"
                    >
                      <span
                        slot="selected-option"
                        slot-scope="option"
                      >
                        {{ option.sideNumber }} ({{ option.registrationNumber }})
                      </span>
                      <template #option="{ registrationNumber, sideNumber }">
                        <span>{{ sideNumber }} ({{ registrationNumber }})</span>
                      </template>
                      <span slot="no-options">{{ $t('popups.user.init-team.select-vehicle-no-result') }}</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>

              <div>
                <validation-provider
                  v-if="!isDriverOnlyTeam"
                  #default="{ errors }"
                  :name="$t('popups.user.init-team.paramedic')"
                  :rules="paramedicValidationRule"
                >
                  <label for="paramedic">
                    {{ $t('popups.user.init-team.paramedic') }}
                  </label>
                  <b-form-group>
                    <v-select
                      id="paramedic"
                      v-model="myTeam.paramedicUser"
                      :placeholder="$t('popups.user.init-team.select-paramedic')"
                      :options="paramedics"
                      :clearable="false"
                      :searchable="false"
                      :reduce="name => name.id"
                      :disabled="paramedicSelectDisabled"
                    >
                      <span
                        slot="selected-option"
                        slot-scope="option"
                      >
                        {{ option.surname }} {{ option.name }}
                      </span>
                      <template #option="{ name, surname }">
                        <span> {{ surname }} {{ name }}</span>
                      </template>
                      <span slot="no-options">{{ $t('popups.user.init-team.select-paramedic-no-result') }}</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
                <b-form-group v-if="showDriverIsParamedicToggle">
                  <b-form-checkbox
                    v-model="driverIsParamedic"
                    @change="handleDriverIsParamedicToggle"
                  >
                    {{ $t('popups.user.init-team.driver-is-paramedic') }}
                  </b-form-checkbox>
                </b-form-group>
              </div>

              <div v-if="showDriverField">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('popups.user.init-team.driver')"
                  rules="required"
                >
                  <label for="driver">
                    {{ $t('popups.user.init-team.driver') }}
                  </label>
                  <b-form-group>
                    <v-select
                      id="driver"
                      v-model="myTeam.driverUser"
                      :placeholder="$t('popups.user.init-team.select-driver')"
                      :options="drivers"
                      :disabled="driverSelectDisabled"
                      :clearable="false"
                      :searchable="false"
                      :reduce="name => name.id"
                    >
                      <span
                        slot="selected-option"
                        slot-scope="option"
                      >
                        {{ option.surname }} {{ option.name }}
                      </span>
                      <template #option="{ name, surname }">
                        <span>{{ surname }} {{ name }}</span>
                      </template>
                      <span slot="no-options">{{ $t('popups.user.init-team.select-driver-no-result') }}</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>
            </form>
          </validation-observer>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <b-button
            v-if="forceShow"
            :disabled="loading"
            variant="flat"
            @click="cancel"
          >
            {{ $t('shared.cancel') }}
          </b-button>
          <b-button
            v-if="!forceShow"
            :disabled="loading"
            variant="flat"
            @click="logout"
          >
            {{ $t('shared.logout') }}
          </b-button>
          <b-button
            variant="primary"
            :disabled="loading"
            @click.prevent="submitForm"
          >
            {{ $t('popups.user.init-team.button') }}
          </b-button>
        </div>
      </template>

    </b-modal>
  </div>
</template>

<script>
import { cloneNested, parseRequestError } from '@/helpers/helpers'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      loading: true,
      myTeam: {
        status: false,
        teamDefinition: null,
        vehicle: null,
        driverUser: null,
        paramedicUser: null,
      },
      driverIsParamedic: false,
    }
  },
  computed: {
    me() {
      return cloneNested(this.$store.getters['auth/getUser'])
    },
    currentTeam() {
      return this.$store.getters['auth/getUserTeam']
    },
    functionalRoles() {
      return Array.isArray(this.me.rawRoles) ? this.me.rawRoles : (this.me.roles || [])
    },
    vehicles() {
      return this.$store.getters['vehicle/getFreeVehicles']
    },
    teamDefinitions() {
      return this.$store.getters['settings/getFreeTeamDefinitions']
    },
    drivers() {
      const list = this.$store.getters['user/getDrivers'] || []
      if (this.isDriverOnlyTeam || this.allowDriverAsParamedic) {
        return list
      }
      const paramedicId = this.myTeam.paramedicUser
      if (!paramedicId) {
        return list
      }
      return list.filter(driver => driver.id !== paramedicId)
    },
    paramedics() {
      const list = this.$store.getters['user/getParamedics'] || []
      if (this.isDriverOnlyTeam) {
        return list
      }
      if (this.allowDriverAsParamedic) {
        return list
      }
      const driverId = this.myTeam.driverUser
      if (!driverId) {
        return list
      }
      return list.filter(paramedic => paramedic.id !== driverId)
    },
    canActAsDriver() {
      return this.functionalRoles.includes('ROLE_DRIVER')
    },
    canActAsParamedic() {
      return this.functionalRoles.includes('ROLE_PARAMEDIC') || this.functionalRoles.includes('ROLE_FIRST_RESPONDER')
    },
    isTeamLeader() {
      return (this.me.roles || []).includes('ROLE_TEAM_LEADER')
    },
    isAdvancedDispatcher() {
      return (this.me.roles || []).includes('ROLE_ADVANCED_DISPATCHER')
    },
    canInitializeTeam() {
      if (this.isAdvancedDispatcher) {
        return true
      }

      return this.isTeamLeader && (this.canActAsDriver || this.canActAsParamedic)
    },
    canCreateTeamWithoutSelf() {
      return this.isAdvancedDispatcher
    },
    forceShow() {
      return this.$store.getters['auth/getShowInitTeamPopup']
    },
    show() {
      if (!this.canInitializeTeam) {
        return false
      }

      return this.forceShow || (this.me.requirePasswordChange === false && this.me.teamLoginOnly === true && !this.currentTeam.id)
    },
    selectedTeamDefinition() {
      return this.teamDefinitions.find(teamDefinition => teamDefinition.id === this.myTeam.teamDefinition) || null
    },
    filteredTeamDefinitions() {
      const names = Array.isArray(this.teamDefinitions) ? this.teamDefinitions : []
      if (this.isAdvancedDispatcher) {
        return names
      }
      const isDriver = this.canActAsDriver
      const isParamedic = this.canActAsParamedic
      if (isDriver && isParamedic) {
        return names
      }
      if (isDriver) {
        return names
      }
      if (isParamedic) {
        return names.filter(name => !name.driverOnly)
      }
      return []
    },
    isDriverOnlyTeam() {
      return Boolean(this.selectedTeamDefinition && this.selectedTeamDefinition.driverOnly)
    },
    allowDriverAsParamedic() {
      return Boolean(this.selectedTeamDefinition && this.selectedTeamDefinition.allowDriverAsParamedic)
    },
    paramedicValidationRule() {
      return this.isDriverOnlyTeam ? '' : 'required'
    },
    paramedicSelectDisabled() {
      if (this.isDriverOnlyTeam) {
        return true
      }
      if (this.driverIsParamedic) {
        return true
      }
      if (!this.canCreateTeamWithoutSelf && this.canActAsParamedic && !this.canActAsDriver) {
        return true
      }
      if (!this.canCreateTeamWithoutSelf && this.canActAsParamedic) {
        return false
      }
      if (!this.canCreateTeamWithoutSelf && this.canActAsDriver) {
        return false
      }
      return (!this.isAdvancedDispatcher) || this.loading
    },
    driverSelectDisabled() {
      if (this.loading) {
        return true
      }

      if (!this.canCreateTeamWithoutSelf && this.canActAsDriver && !this.canActAsParamedic) {
        return true
      }

      return false
    },
    showDriverIsParamedicToggle() {
      return this.canActAsDriver && this.canActAsParamedic && this.allowDriverAsParamedic && !this.isDriverOnlyTeam
    },
    showDriverField() {
      return !this.driverIsParamedic
    },
    teamDefinitionHint() {
      if (this.isDriverOnlyTeam) {
        return this.$t('popups.user.init-team.hints.driver-only')
      }
      if (this.allowDriverAsParamedic) {
        return this.$t('popups.user.init-team.hints.allow-driver-as-paramedic')
      }
      if (!this.allowDriverAsParamedic && !this.isDriverOnlyTeam) {
        return this.$t('popups.user.init-team.hints.driver-and-paramedic-different')
      }
      return ''
    },
  },
  watch: {
    'myTeam.teamDefinition': 'handleTeamDefinitionChange',
    'myTeam.paramedicUser': function paramedicWatcher(newValue) {
      if (this.driverIsParamedic) {
        this.$set(this.myTeam, 'driverUser', newValue)
      } else if (this.showDriverIsParamedicToggle && newValue && this.myTeam.driverUser === newValue) {
        this.driverIsParamedic = true
      }
    },
    'myTeam.driverUser': function driverWatcher(newValue) {
      if (this.driverIsParamedic && newValue !== this.myTeam.paramedicUser) {
        this.driverIsParamedic = false
      }
      if (
        this.showDriverIsParamedicToggle
        && newValue
        && this.myTeam.paramedicUser
        && newValue === this.myTeam.paramedicUser
      ) {
        this.driverIsParamedic = true
      }
    },
    filteredTeamDefinitions: {
      handler(newList) {
        if (!Array.isArray(newList)) {
          return
        }
        const currentId = this.myTeam.teamDefinition
        const found = newList.some(teamDefinition => teamDefinition.id === currentId)
        if (!found) {
          const nextId = newList.length ? newList[0].id : null
          this.$set(this.myTeam, 'teamDefinition', nextId)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.show) {
      this.$bvModal.show('modal-team-init')
      this.init(this.show)
    }
  },
  created() {
  },
  methods: {
    shouldFetchDrivers() {
      return true
    },
    shouldFetchParamedics() {
      return !this.isDriverOnlyTeam
    },
    handleTeamDefinitionChange() {
      if (!this.showDriverIsParamedicToggle && this.driverIsParamedic) {
        this.driverIsParamedic = false
      }
      if (this.isDriverOnlyTeam) {
        this.$set(this.myTeam, 'paramedicUser', null)
      }
      const shouldResetDriver = !this.showDriverIsParamedicToggle
      const shouldResetParamedic = this.isDriverOnlyTeam
      this.assignDefaultMembers({ resetDriver: shouldResetDriver, resetParamedic: shouldResetParamedic })
      if (
        !this.allowDriverAsParamedic
        && !this.isDriverOnlyTeam
        && this.myTeam.driverUser
        && this.myTeam.driverUser === this.myTeam.paramedicUser
      ) {
        this.$set(this.myTeam, 'driverUser', null)
      }
    },
    handleDriverIsParamedicToggle(value) {
      if (value) {
        this.$set(this.myTeam, 'driverUser', this.myTeam.paramedicUser)
        return
      }
      if (!this.canCreateTeamWithoutSelf && this.canActAsDriver) {
        this.$set(this.myTeam, 'driverUser', this.me.id)
      } else {
        this.$set(this.myTeam, 'driverUser', null)
      }
    },
    assignDefaultMembers(options = {}) {
      const { resetDriver = false, resetParamedic = false } = options
      if (resetDriver) {
        this.$set(this.myTeam, 'driverUser', null)
      }
      if (resetParamedic) {
        this.$set(this.myTeam, 'paramedicUser', null)
      }
      if (!this.canCreateTeamWithoutSelf) {
        if (this.canActAsDriver && !this.canActAsParamedic) {
          this.$set(this.myTeam, 'driverUser', this.me.id)
        }
        if (this.canActAsParamedic && !this.canActAsDriver && !this.isDriverOnlyTeam) {
          this.$set(this.myTeam, 'paramedicUser', this.me.id)
        }
        if (this.canActAsDriver && this.canActAsParamedic) {
          if (this.isDriverOnlyTeam) {
            this.$set(this.myTeam, 'driverUser', this.me.id)
          } else {
            this.$set(this.myTeam, 'paramedicUser', this.me.id)
            if (this.allowDriverAsParamedic && this.driverIsParamedic) {
              this.$set(this.myTeam, 'driverUser', this.me.id)
            }
          }
        }
      }
      if (this.driverIsParamedic) {
        this.$set(this.myTeam, 'driverUser', this.myTeam.paramedicUser)
      }
    },
    validateTeamMembers() {
      if (this.isDriverOnlyTeam) {
        this.$set(this.myTeam, 'paramedicUser', null)
      }
      if (!this.isDriverOnlyTeam && !this.myTeam.paramedicUser) {
        window.toast.notify.danger(this.$t('popups.user.init-team.validation.paramedic-required'))
        return false
      }
      if (
        !this.allowDriverAsParamedic
        && !this.isDriverOnlyTeam
        && this.myTeam.paramedicUser
        && this.myTeam.driverUser
        && this.myTeam.paramedicUser === this.myTeam.driverUser
      ) {
        window.toast.notify.danger(this.$t('popups.user.init-team.validation.driver-and-paramedic-different'))
        return false
      }
      if (!this.canCreateTeamWithoutSelf && (this.canActAsDriver || this.canActAsParamedic)) {
        const selfDriver = this.canActAsDriver && this.myTeam.driverUser === this.me.id
        const selfParamedic = this.canActAsParamedic && !this.isDriverOnlyTeam && this.myTeam.paramedicUser === this.me.id
        if (!selfDriver && !selfParamedic) {
          window.toast.notify.danger(this.$t('popups.user.init-team.validation.must-assign-self'))
          return false
        }
      }
      return true
    },
    init(initialize) {
      if (!initialize) {
        return
      }

      const coreRequests = [
        this.$store.dispatch('vehicle/fetchFreeVehicles'),
        this.$store.dispatch('settings/fetchFreeTeamDefinitions'),
      ]

      Promise.all(coreRequests)
        .then(() => this.$nextTick())
        .then(() => {
          const memberRequests = []

          if (this.shouldFetchDrivers()) {
            memberRequests.push(this.$store.dispatch('user/fetchDrivers'))
          }

          if (this.shouldFetchParamedics()) {
            memberRequests.push(this.$store.dispatch('user/fetchParamedics'))
          }

          return Promise.all(memberRequests)
        })
        .then(() => {
          this.assignDefaultMembers({ resetDriver: true, resetParamedic: true })
        })
        .catch(error => {
          parseRequestError(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitForm() {
      this.loading = true
      this.$refs.initTeamValidation.validate()
        .then(valid => {
          if (!valid) {
            return false
          }
          if (!this.validateTeamMembers()) {
            this.loading = false
            return false
          }
          this.$store.dispatch('team/addTeam', this.myTeam)
            .then(() => {
              window.toast.notify.success(this.$t('popups.user.init-team.notify.success'))
              this.$store.dispatch('auth/fetchUserTeam')
              this.$store.dispatch('auth/setShowInitTeamPopup', false)
              this.clearForm()
            })
            .catch(err => parseRequestError(err))
            .finally(() => {
              this.loading = false
            })

          return true
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancel() {
      this.$store.dispatch('auth/setShowInitTeamPopup', false)
    },
    logout() {
      this.$store.dispatch('auth/logout')
        .then(() => this.$router.push('/login'))
    },
    clearForm() {
      this.myTeam = {
        status: false,
        teamDefinition: null,
        vehicle: null,
        driverUser: null,
        paramedicUser: null,
      }
      this.driverIsParamedic = false
    },
    getVehicleOptionLabel(option) {
      if (!option) {
        return ''
      }

      return `${option.sideNumber} (${option.registrationNumber})`
    },
  },
}
</script>
